// @ts-nocheck
/* eslint-disable */
export const appDistance40Icon = {
    data: `<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M33 15.5V24.5M7 15.5V24.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M11 20H29M14.375 24.5L11 20L14.375 15.5M25.625 24.5L29 20L25.625 15.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`,
    name: 'distance-40' as const
};